// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../../../routes/routes";
import { supportedLanguages } from "../../../../i18n/supported-languages";
import phrasebookLoad from "../../../../i18n";
import { capitalizeFirstLetter } from "../../../../helpers/util"
import * as token from '../../../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../../../constants';

// Redux
import { accountActions, customerActions, georesourceActions } from 'actions';

// Components
import { NewBreadcrumbs } from "../../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SubmitButton, CancelButton } from "../../../../components/SkyFramework/Buttons";
import { Form } from "../../../../components/SkyFramework/Forms";

// Constants
const languageOptions = supportedLanguages.map(function (lang) {
  return { value: lang['code'], label: lang['language'] };
});
const phrasebook = phrasebookLoad()

class AccountAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      account_type_id: 200,
      username: undefined,
      email: undefined,
      customer_id: parseInt(this.props.match.params.id),
      status: 'created',
      disabled: true,
      submitted: false
    }
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {

  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var newValues = {
      username: this.state.username,
      email: this.state.email,
      account_type_id: this.state.account_type_id,
      customer_id: this.state.customer_id,
      status: this.state.status,
      disabled: this.state.disabled
    }
    this.props.dispatch(accountActions.addInterimAccount(newValues));
  }

  FormProfile = () => {

    const inputs = [
      // { label: phrasebook.profile.username, type: "text", placeholder: this.state.username, id: "username", name: "username", value: this.state.username, required: true },
      { label: phrasebook.profile.email, type: "text", placeholder: this.state.email, id: "email", name: "email", value: this.state.email, required: true },
    ]
    const buttons = [<CancelButton title={phrasebook.common.back} link={gisRoutes.account.account.list} />, <SubmitButton title={phrasebook.common.add} />]
    return (
      <Form
        handleSubmit={this.handleSubmit}
        onChange={this.handleChange}
        title={phrasebook.profile.master_information}
        inputs={inputs}
        buttons={buttons}
      />)

  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.account.account.list, label: phrasebook.headerlinks.accounts }]} current={phrasebook.profile.master_link} />

      {this.FormProfile()}
    </>
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { authUser } = authentication;
  return {
    authUser
  };
}


const userAdd = connect(mapStateToProps)(AccountAdd);
export default (userAdd);
